export default __webpack_public_path__ + "static/media/s3_item1.5d96ffdc.png";